import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ImportSelectedItem {
  id: string;
  name: string;
  data_type: string;
  status?: string;
  created_at?: string;
  fk_folder_id?: string | null;
  owner?: string;
  description?: string;
}

interface ImportSidebarState {
  selectedItems: ImportSelectedItem[];
  selectedFolders: string[];
  isImporting: boolean;
}

const initialState: ImportSidebarState = {
  selectedItems: [],
  selectedFolders: [],
  isImporting: false,
};

const importSidebarSlice = createSlice({
  name: 'importSidebar',
  initialState,
  reducers: {
    toggleItemSelection: (state, action: PayloadAction<ImportSelectedItem>) => {
      const index = state.selectedItems.findIndex(item => item.id === action.payload.id);
      if (index >= 0) {
        state.selectedItems.splice(index, 1);
      } else {
        state.selectedItems.push(action.payload);
      }
    },
    addToSelection: (state, action: PayloadAction<ImportSelectedItem>) => {
      if (!state.selectedItems.some(item => item.id === action.payload.id)) {
        state.selectedItems.push(action.payload);
      }
    },
    selectAll: (state, action: PayloadAction<ImportSelectedItem[]>) => {
      if (state.selectedItems.length === action.payload.length) {
        state.selectedItems = [];
      } else {
        state.selectedItems = action.payload;
      }
    },
    toggleFolderSelection: (state, action: PayloadAction<{ folderId: string; datasourcesInFolder: ImportSelectedItem[] }>) => {
      const { folderId, datasourcesInFolder } = action.payload;
      const index = state.selectedFolders.indexOf(folderId);
      if (index >= 0) {
        state.selectedFolders.splice(index, 1);
        const folderDsIds = new Set(datasourcesInFolder.map(ds => ds.id));
        state.selectedItems = state.selectedItems.filter(item => !folderDsIds.has(item.id));
      } else {
        state.selectedFolders.push(folderId);
        for (const ds of datasourcesInFolder) {
          if (!state.selectedItems.some(item => item.id === ds.id)) {
            state.selectedItems.push(ds);
          }
        }
      }
    },
    setIsImporting: (state, action: PayloadAction<boolean>) => {
      state.isImporting = action.payload;
    },
    clearSelections: (state) => {
      state.selectedItems = [];
      state.selectedFolders = [];
    },
  },
});

export const {
  toggleItemSelection,
  addToSelection,
  selectAll,
  toggleFolderSelection,
  setIsImporting,
  clearSelections,
} = importSidebarSlice.actions;

export default importSidebarSlice.reducer;
